import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer";

import { postForgetPassword } from "../../../helpers/backend_helper";

const extractErrorMessage = (payload: any) => {
  const data = payload?.response?.data ?? payload;

  if (typeof data === "string") return data;
  if (data?.message) return data.message;

  if (data?.errors && typeof data.errors === "object") {
    const firstKey = Object.keys(data.errors)[0];
    const firstError = data.errors[firstKey];

    if (Array.isArray(firstError)) return firstError[0];
    if (typeof firstError === "string") return firstError;
  }

  return "Gửi email đặt lại mật khẩu không thành công. Vui lòng thử lại.";
};

export const userForgetPassword = (user: { email: string }) => async (dispatch: any) => {
  try {
    const response: any = await postForgetPassword({
      email: user.email,
    });

    const responseMessage = response?.data?.message ?? response?.message;
    const successMessage =
      typeof responseMessage === "string" && responseMessage.trim() !== ""
        ? responseMessage
        : "Đã gửi liên kết đặt lại mật khẩu. Vui lòng kiểm tra email của bạn.";

    dispatch(
      userForgetPasswordSuccess(
        successMessage,
      ),
    );
  } catch (forgetError: any) {
    dispatch(userForgetPasswordError(extractErrorMessage(forgetError)));
  }
};
